import { ApolloClient, InMemoryCache, HttpLink } from '@apollo/client'
import fetch from 'cross-fetch'

// Get WordPress GraphQL endpoint from environment
const WORDPRESS_URL = process.env.GATSBY_WORDPRESS_URL || process.env.SITE_URL || 'https://admin.strikeforce.com.au'

const client = new ApolloClient({
  link: new HttpLink({
    uri: `${WORDPRESS_URL}/graphql`,
    fetch,
  }),
  cache: new InMemoryCache(),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'cache-and-network',
    },
  },
})

export default client

